"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#014864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m7.67958 22.29979a.49972.49972 0 0 1 -.5-.5v-1a.5.5 0 0 1 1 0v1a.49972.49972 0 0 1 -.5.5zm0-4a.49972.49972 0 0 1 -.5-.5v-1a.5.5 0 0 1 1 0v1a.49972.49972 0 0 1 -.5.5zm8.64063-11.35938a.49971.49971 0 0 1 -.5-.5v-1a.5.5 0 0 1 1 0v1a.49971.49971 0 0 1 -.5.5zm0-4a.49971.49971 0 0 1 -.5-.5v-1a.5.5 0 0 1 1 0v1a.49971.49971 0 0 1 -.5.5zm-7.64063 6.86194v-5.20447a2.42019 2.42019 0 1 0 -2-.00024v5.20508a2.4205 2.4205 0 1 0 2-.00037zm-2.41992-7.402a1.42041 1.42041 0 1 1 1.41992 1.41995 1.4212 1.4212 0 0 1 -1.41992-1.41993zm1.41992 11.01955a1.41992 1.41992 0 1 1 1.4209-1.4199 1.4212 1.4212 0 0 1 -1.4209 1.4199zm9.64063 5.98243v-5.20508a2.41993 2.41993 0 1 0 -2 0v5.20508a2.41993 2.41993 0 1 0 2 0zm-2.41992-7.40233a1.41992 1.41992 0 1 1 1.41992 1.41992 1.4212 1.4212 0 0 1 -1.41992-1.41992zm1.41992 11.01953a1.41992 1.41992 0 1 1 1.41992-1.41992 1.4212 1.4212 0 0 1 -1.41992 1.4199z"
  }));
};

exports["default"] = _default;